import React from "react";
import { Story } from "../../../types";
import AvatarHeader from "../avatar-header/avatar-header";
import { SafeJoin } from "../../../util";
import PrevSubmission from "../prev-submission/prev-submission";

type Props = {
  story: Story;
  multiPrompt?: boolean;
};

const CanvasViewSolo = ({ story, multiPrompt }: Props) => {
  const headerNoPlayer = (
    <AvatarHeader
      tall
      titlesJsx={[
        <span className={"font-bold underline"}>{story.meta.title}</span>,
        <>
          characters:{" "}
          {SafeJoin(
            story.characters
              ?.filter((c) => c.selected)
              .map<React.ReactNode>((c) => (
                <i key={"char-" + c.id}>{c.name}</i>
              )),
            ", "
          )}{" "}
        </>,
      ]}
    />
  );

  return (
    <div
      className={
        "h-full w-full -z-10 absolute overflow-y-scroll overflow-x-hidden"
      }
    >
      <div
        id={"canvas-" + story.id}
        className={
          "flex-grow relative flex flex-col items-stretch pb-8 bg-gray-light"
        }
      >
        {headerNoPlayer}
        <div className={"relative flex-grow flex flex-col"}>
          <div className={"flex-grow flex flex-col"}>
            {story.submissions.map<React.ReactNode>((s, idx) => {
              return (
                <div key={"canvas-submission-" + s.id}>
                  <div
                    className={
                      "px-4 pt-2 text-base break-words whitespace-pre-wrap normal-case"
                    }
                  >
                    <PrevSubmission variant="read" submission={s} />
                    {multiPrompt || s.index === story.submissions.length - 1 ? (
                      <div className={"vote-row-buttons italic mt-2"}>
                        prompt: {s.meta.prompt}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CanvasViewSolo;
